var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"mode":"out-in","appear":""},on:{"before-enter":_vm.openInTop}},[_c('router-view')],1),_c('router-link',{staticClass:"shopping-now",attrs:{"to":"/order"}},[_c('i',{staticClass:"fas fa-shopping-cart"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }